<template lang="pug">	
	.ai-music--keywords-selector.flex-col.space-medium
		.flex-col.space(v-if="!selectedRootItem", v-for="group in rootItems")
			.font-small.upper.grey.flex-row.align-center.space 
				.flex-row
					span (
					.key(v-for="key in getAltKeyInfo(group.altKey)") {{key.key}}
					span )
				span {{group.Name}}
			.keywords-list.flex-row.justify.space.align-center.clickable(@click="selectedRootItem = group", :class="{ 'has-placeholder': !getSelectedValue(group).length }", :data-dx_placeholder="$tCaption('Select..')")
				.flex-row.space.wrap
					.keyword.flex-row.space.align-center.clickable(v-for="item in getSelectedValue(group)")
						span {{item.Name}}
						.button.flex-row.align-center.center.clickable(@click.stop="$Data.toggleSelectedIdInArray(item.Oid, innerValue)")
							fas(icon="times")
				.button.big.flex-row.align-center.center.clickable(@click.stop="clearAll(group)")
					fas(icon="times")
		.flex-col.space(v-if="selectedRootItem")
			.flex-row.space.align-center
				.upper.grey.flex-row.space.align-center.clickable.hoverable(@click="itemBack")
					fas(icon="arrow-left")
					span ({{$tCaption('Esc')}})
				.font-big.upper.flex-row.space
					span {{selectedRootItem.Name}}
			.flex-row.wrap
				.sub-item.flex-row.space.align-center.clickable(v-for="si in subItems", @click="processItemClick(si)", :class="{ active: innerValue.includes(si.Oid) || si.allItems.some(f => innerValue.includes(f.Oid)) }")
					.upper.grey.flex-row.space-small.align-center(v-if="helperVisible")
						.flex-row
							span (
							.key(v-for="key in getAltKeyInfo(si.altKey)", :class="{ active: key.combined }") {{key.key}}
							span )
					span {{si.Name}}
			.flex-row.space.font-small(v-if="subItems.length")
				.upper.grey.clickable.hoverable(@click="clearAll") {{$tCaption('(delete) Clear selected items')}}
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxTagBox from 'devextreme-vue/tag-box';

	export default {
		translationCategory: 'aiMusic.KeywordsSelector',
		name: 'ai-music--keywords-selector',
		components: { Loader, DxTagBox },
		props: ['value', 'keysActive'],
		data() {
			return {
				keywords: [],
				innerValue: [],
				helperVisible: true,
				selectedRootItem: null,
				lastCombination: ''
			};
		},
		computed: {
			rootItems() {
				return this.prepareKeys(this.keywords.filter(f => !f.Parent?.Oid));
			},
			subItems() {
				return this.prepareKeys(this.keywords.filter(f => this.selectedRootItem && f.Parent?.Oid === this.selectedRootItem?.Oid));
			}
		},
		watch: {
			innerValue() {
				if (this.$isUpdating) return;
				this.$isUpdating = true;
				this.$emit('update:value', this.innerValue.join(','));
				this.$emit('value-changed', this.innerValue.join(','));
				setTimeout(() => this.$isUpdating = false, 100);
			},
			value(v) {
				if (this.$isUpdating) return;				
				this.$isUpdating = true;
				this.innerValue = (v || '').split(',').filter(f => f);
				setTimeout(() => this.$isUpdating = false, 100);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.aiMusicKeywordsSelector = this;

			this.loadKeywords();
			this.$isUpdating = true;
			this.innerValue = (this.value || '').split(',').filter(f => f);
			setTimeout(() => this.$isUpdating = false, 100);

			document.addEventListener('keydown', this.onKeyDown);
			document.addEventListener('keyup', this.onKeyUp);
		},
		destroyed() {
			delete this.$isUpdating;
			document.removeEventListener('keydown', this.onKeyDown);
			document.removeEventListener('keyup', this.onKeyUp);
		},
		methods: {
			getAltKeyInfo(key) {
				key = key || '';
				let comb = (this.lastCombination || '').substr(-1 * key.length);
				return key.split('').map((f, i) => ({
					key: f,
					combined: key.slice(0, i + 1) === comb.slice(0, i + 1)
				}))
			},
			prepareKeys(arr) {
				let len = arr.length >= 100 ? 3 : arr.length >= 10 ? 2 : 1;
				let nils = '0'.repeat(len - 1);
				return (arr || []).map((f, idx) => {
					f.altKey = `${nils}${idx + 1}`.substr(-1 * len);

					return f;
				});
			},
			isInput() {
				var activeElement = document.activeElement;
				var inputs = ['input', 'select', 'button', 'textarea'];
				var classes = activeElement ? [...activeElement.classList] : [];

				return activeElement && (inputs.indexOf(activeElement.tagName.toLowerCase()) > -1 || classes.includes('jodit-wysiwyg'));
			},
			clearAll(group) {
				group = group || this.selectedRootItem;
				if (!group) return;
				group.allItems.map(f => {
					if (this.innerValue.includes(f.Oid)) {
						this.$Data.toggleSelectedIdInArray(f.Oid, this.innerValue);
					}
				});
			},
			onKeyDown(e) {
				if (this._isDestroyed || this.isInput()) return;
				
				if (!isNaN(e.key)) {
					this.lastCombination = ((this.lastCombination || '') + e.key).substr(-3);
				}
				let items = this.selectedRootItem ? this.keywords.filter(f => f.Parent?.Oid === this.selectedRootItem?.Oid) : this.rootItems;
				let item = items.find(f => f.altKey == this.lastCombination.substr(-1 * f.altKey.length));

				if (__DEBUG__)
					console.debug('KeyDown', { e, key: e.key, item, comb: this.lastCombination, items });

				if (e.key === 'Escape' && this.selectedRootItem) {
					this.itemBack();
					return;
				}

				if (e.key === 'Delete' && this.selectedRootItem) {
					this.clearAll();
					return;
				}

				if (e.key === 'Backspace') {
					if (this.lastCombination?.length) {
						this.lastCombination = this.lastCombination.substr(0, this.lastCombination.length - 2);
					} else {
						this.selectedRootItem = null;
					}
					return;
				}

				this.processItemClick(item);
			},
			itemBack() {
				this.selectedRootItem = this.keywords.find(f => f.Oid === this.selectedRootItem?.Parent?.Oid);
			},
			processItemClick(item) {
				if (item) {
					if (this.keywords.some(f => f.Parent?.Oid === item?.Oid)) {
						this.selectedRootItem = item;
					} else {
						this.$Data.toggleSelectedIdInArray(item.Oid, this.innerValue);
					}
					this.lastCombination = '';
				}
			},
			onKeyUp(e) {
				if (this._isDestroyed || this.isInput()) return;
			},
			initKeyHandlers() {
				
			},
			async loadKeywords() {
				this.keywords = (await this.$Data.getExternalApi('AiMusicKeyword/List', '', 9999, true))?.Results;

				this.keywords.map(f => {
					f.allItems = this.getGroupItems(f);
				});
			},
			getGroupItems(group) {
				let result = [];

				let pushAllItems = (items) => {
					items.map(f => {
						result.push(f);
						pushAllItems(this.keywords.filter(k => k.Parent?.Oid === f.Oid));
					});
				}

				let items = _.orderBy(this.keywords.filter(f => f.Parent?.Oid === group?.Oid), ['Name']);
				pushAllItems(items);

				return result;
			},
			onValueChanged(group, e) {
				if (this.$isUpdating) return;

				let added = e.value.filter(f => !e.previousValue.includes(f));
				let removed = e.previousValue.filter(f => !e.value.includes(f));

				if (__DEBUG__)
					console.debug('onValueChanged', { e, added, removed });

				added.map(f => this.$Data.toggleSelectedIdInArray(f, this.innerValue));
				removed.map(f => this.$Data.toggleSelectedIdInArray(f, this.innerValue));
			},
			getSelectedValue(group) {
				return group.allItems.filter(f => this.innerValue.includes(f.Oid));
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ai-music--keywords-selector {
		.sub-item {
			padding: 4px 6px;
			margin: 2px;
			background: rgba(255, 255, 255, 0.1);
			border-radius: 4px;

			&.active {
				background: $base-accent;
			}
		}

		.key {
			&.active {
				background: rgba(255, 255, 255, 0.5);
				color: $base-accent;
			}
		}

		.keywords-list {
			background: #f5f5f5;
			border-radius: 4px;
			padding: 0px 4px 2px !important;
			min-height: 37px;

			.keyword {
				padding: 6px 8px 6px 12px;
				min-width: 40px;
				background-color: #e0e0e0;
				color: rgba(0, 0, 0, .6);
				border-radius: 16px;
			}

			.button {
				border-radius: 50%;
				background-color: rgba(0, 0, 0, .36);
				width: 16px;
				height: 16px;
				color: #e0e0e0;

				&:hover {
					color: #fff;
				}

				&.big {
					background-color: rgba(194, 194, 194, .87);
					color: rgba(117, 117, 117, .87);
					width: 22px;
					height: 22px;
					font-size: 12px;
				}
			}

			
			&.has-placeholder:before {
				display: inline-block;
				vertical-align: middle;
				max-width: 100%;
				text-overflow: ellipsis;
				overflow: hidden;
				content: attr(DATA-DX_PLACEHOLDER);
				pointer-events: none;
				white-space: nowrap;
				color: rgba(148, 148, 148, 0.47) !important;
				font-size: 16px;
			}
		}
	}
</style>
 